import React from "react";
import html from "../../assets/html.svg";
import css from "../../assets/css.svg";
import react from "../../assets/react.svg";
import js from "../../assets/js.svg";
import redux from "../../assets/redux.svg";
import tw from "../../assets/tw.svg";
import node from "../../assets/node.svg";
import exp from "../../assets/exp.svg";
import psql from "../../assets/psql.svg";
import seq from "../../assets/seq.svg";
import ts from "../../assets/ts.svg";

const Experience = () => {

  const frontEndTech = [
    { src: js, alt: "JS Logo", title: "Javascript" },
    { src: react, alt: "REACT Logo", title: "React" },
    { src: html, alt: "HTML Logo", title: "HTML5" },
    { src: css, alt: "CSS Logo", title: "CSS" },
    { src: redux, alt: "REDUX Logo", title: "Redux" },
    { src: tw, alt: "TW Logo", title: "Tailwind" },
  ];

  const backEndTech = [
    { src: node, alt: "NODE Logo", title: "NodeJS" },
    { src: exp, alt: "EXP Logo", title: "ExpressJs" },
    { src: psql, alt: "PSQL Logo", title: "PostgreSQL" },
    { src: seq, alt: "SEQ Logo", title: "Sequelize" },
    { src: js, alt: "JS Logo", title: "Javascript" },
    { src: ts, alt: "TS Logo", title: "Typescript" },
  ];

  return (
    <section id="experience" className="py-12 bg-white">
      <h5 className="text-title">My Skills</h5>
      <h2 className="text-subtitle">Technologies</h2>

      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="skill-conteiner">
        <h3 className="skill-banner">Front-End</h3>
          <div className="grid grid-cols-2 gap-y-8">
            {frontEndTech.map(({ src, alt, title }) => (
              <article
                key={title}
                className="skills_details"
              >
                <img
                  src={src}
                  alt={alt}
                  className="h-10 mr-4"
                />
                <div>
                  <h4 className="skills-title">{title}</h4>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="skill-conteiner">
          <h3 className="skill-banner">Back-End</h3>
          <div className="grid grid-cols-2 gap-y-8">
            {backEndTech.map(({ src, alt, title }) => (
              <article key={title} 
              className="skills_details">
                <img
                  src={src}
                  alt={alt}
                  className="h-10 mr-4"
                />
                <div>
                  <h4 className="skills-title">{title}</h4>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
